import {
  CAMPAIGN_DEFAULT_REQ_FIELDS,
  CAMPAIGN_GOALS,
  CAMPAIGN_IN_KIND_REQ_FIELDS,
} from '@/lib/configs/campaigns';

const validateCampaignFormData = (formData) => {
  const errors = {};

  const { goalType } = formData;

  let requiredFields = CAMPAIGN_DEFAULT_REQ_FIELDS;

  // for in kind campaigns
  if (goalType === CAMPAIGN_GOALS[1].value) {
    requiredFields = requiredFields.concat(CAMPAIGN_IN_KIND_REQ_FIELDS);
  }

  requiredFields.forEach((field) => {
    const val = formData[field];

    if (val?.length === 0 || (!val && val !== 0)) {
      errors[field] = true;
    }

    // The forms that use this function should have proper form validation set
    // up. In the interest of time, creating a one-off rule for fields with "0" default.
    // Hestitant to update the logic above for fear of creating more bugs with
    // other fields.
    if (
      (field === 'goalAmount' ||
        field === 'ticketPrice' ||
        field === 'itemQuantity' ||
        field === 'itemValue') &&
      !val
    ) {
      errors[field] = true;
    }
  });

  return errors;
};

export default validateCampaignFormData;
